import PropTypes from 'prop-types'
import React from 'react'


class ImageStatic extends React.PureComponent {

  constructor(props) {
    super(props)
    const { lazyLoad } = props

    this.lazyRef = React.createRef()
    this.io = null
    this.state = {
      visible: !lazyLoad,
    }
  }

  componentDidMount() {
    const { lazyLoad: lazyLoad1 } = this.props

    if (lazyLoad1 && this.shouldUseIntersectionManager()) {
      this.io = new IntersectionObserver(this.intersectionHandler, {
        rootMargin: '500px',
        threshold: 0,
      })
      this.io.observe(this.lazyRef.current)
    }
  }

  intersectionHandler = (entries) => {
    const entry = entries[0]

    if (entry && entry.isIntersecting) {
      this.io.unobserve(this.lazyRef.current)
      this.setState({
        visible: true,
      })
      this.io.disconnect()
    }
  }

  componentWillUnmount() {
    if (this.io) {
      this.io.disconnect()
    }
  }

  shouldUseIntersectionManager() {
    if (!process.browser) {
      const { lazyLoad } = this.props

      return lazyLoad
    }
    if (!('IntersectionObserver' in window)) {
      require('intersection-observer')
    }
    return true
  }

  renderImage() {
    const { src, srcSet, ...props } = this.props

    return (
      <img
        {...props}
        src={src}
        {...(srcSet ? { srcSet } : {})}
        alt={this.computeAlt()}
      />
    )
  }

  computeAlt = () => {
    const { src, alt } = this.props

    return alt !== null
      ? alt
      : src
        .split('/')
        .pop()
        .split('-')
        .join(' ')
        .split('.')[0]
  }

  render() {
    const { children, className } = this.props
    const { visible: visibleState } = this.state
    const visible = this.shouldUseIntersectionManager() ? visibleState : true

    return visible ? (
      <picture className={className}>
        {children}
        {this.renderImage()}
      </picture>
    ) : (
      <div
        ref={this.lazyRef}
        className={className}
      />
    )
  }

}

ImageStatic.propTypes = {
  src: PropTypes.string.isRequired,
  srcSet: PropTypes.string,
  children: PropTypes.node,
  alt: PropTypes.string,
  className: PropTypes.string,
  lazyLoad: PropTypes.bool,
}

ImageStatic.defaultProps = {
  className: '',
  srcSet: '',
  children: null,
  lazyLoad: false,
  alt: null,
}

export default ImageStatic
